module.exports = __webpack_public_path__ + "img/absolute-radio.5219f008.png";